import React, { useContext } from 'react';
import { WidthContext } from '../../WidthContext';
import './infographic.scss';

function Infographic({ data }) {
  const { caption, imageD, imageM, desc, src } = data;
  const { viewSize } = useContext(WidthContext);
  return (
    <figure className="infographic">
      <img src={viewSize === 'large' ? imageD : imageM} alt={desc} />
      <figcaption>
        <span className="infographic__src">{src}: </span>
        {caption}
      </figcaption>
    </figure>
  );
}

export default Infographic;
